import React from "react";

interface Props {
    id?: string;
    labelText?: string;
    required?: boolean;
    isInvalid?: boolean;
    type?: string;
}

const TextInput = (props: Props, ref: any) => {
    const { id, labelText, required, isInvalid, type, ...rest } = props;

    return (
        <div className="form-group mb-3">
            {labelText ? (
                <label htmlFor={id}>
                    {labelText}
                    {required && <span className="text-danger">*</span>}
                </label>
            ) : (
                ""
            )}

            <input
                {...rest}
                id={id}
                ref={ref}
                className={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                type={type ? type.toLowerCase() : "text"}
                placeholder={`Enter ${labelText}`}
                required={required}
                autoComplete="off"
            />
            {isInvalid && <div className="invalid-feedback">Invalid Value</div>}
        </div>
    );
};

export default React.forwardRef(TextInput);
